import './FooterStyle.css'
import Logo from "../../../assest/ahbaab/Whatsapp-Chat-Icon-1.webp";
import { ErrorMessage, Field, Form, Formik } from "formik"
import * as yup from 'yup'
import { Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { MdLocationPin, MdCall, MdEmail } from "react-icons/md";
import facebookIcon from '../../../assest/ahbaab/facebook.png';
import InstagramIcon from '../../../assest/ahbaab/instagram.png';
import LinkedInIcon from '../../../assest/ahbaab/linkedin.png';

const Footer = () => {
    const defalutValue = {
        EmailAddress: '',

    }

    const validationSceema = yup.object().shape({
        // fieldLbale: yup.string().required('SS').min(10).max(10),
        EmailAddress: yup.string().required('Email is Requird!'),

    })
    const handleSubmit = (value) => {
        console.log(value);
    }


    return (
        <>

            <div className="newfooter">
                <div className="">
                    <div className="footer_links">
                        <div className="row">


                            <div className="col-md-4">
                                <div className="footerlnk-head">Quick Links</div>
                                <ul className="menu_div">
                                    <li><Link to="/">Home</Link></li>
                                    <li><Link to="/about-us">About Us</Link></li>
                                    <li><Link to="/products">Products </Link></li>
                                    <li><Link to="/contact-us">Contact Us </Link></li>
                                    {/* <li><Link to="/privacy_policy">Privacy Policy</Link></li>
                                    <li><Link to="/terms_conditions">Terms & Conditions</Link></li>
                                    <li><Link to="/blogs">Blogs</Link></li>
                                    <li><Link to="/FAQ">FAQ</Link></li> */}

                                </ul>
                            </div>

                            <div className="col-md-4">
                                <div className="footerlnk-head">Category</div>
                                <ul className="menu_div">
                                    <li><Link to="/products/clean-room-consumables">Cleanroom Consumables</Link></li>
                                    <li><Link to="/products/clean-room-protection">Cleanroom Protection</Link></li>
                                    <li><Link to="/products/visual-inspection-kits">Visual Inspection Kits</Link></li>
                                    <li><Link to="/products/cleaning-accessories">Cleaning Accessories</Link></li>

                                </ul>

                            </div>

                            <div className="col-md-4">
                                <div className="footerlnk-head">Contact Us</div>
                                <ul className="menu_div text-right">
                                    <li className="fw-bold">QU - LUCENCY PRIVATE LIMITED</li>
                                    <li className=' mt-3 d-flex align-items-start'>303, Kishan apt, Jamia Nagar, New Delhi, South Delhi- 110025, Delhi</li>
                                    <li className=' mt-3 d-flex align-items-start'><MdCall className=' me-2 fs-4' /><Link to="tel:+91 8448783350">+91 8448783350</Link></li>
                                    <li className=' mt-3 d-flex align-items-start'><MdEmail className=' me-2 fs-4' /><Link to="mailto:info@qu-lucency.com">info@qu-lucency.com</Link></li>
                                    <li className=' mt-3 d-flex align-items-start'><MdEmail className=' me-2 fs-4' /><Link to="mailto:sales@qu-lucency.com">sales@qu-lucency.com</Link></li>
                                    
                                </ul>

                                <ul className="soc_ul_footer">
                                    {/* <li>
                                        <a href="/" target="_blank">
                                            <img src={LinkedInIcon} alt="LinkedIn" />
                                        </a>
                                    </li>

                                    <li>
                                        <a href="/" target="_blank">
                                            <img src={InstagramIcon} alt="Instagram" />
                                        </a>
                                    </li>

                                    <li>
                                        <a href="/" target="_blank">
                                            <img src={facebookIcon} alt="Facebook" />
                                        </a>
                                    </li> */}

                                    <Link to={'https://wa.me/918448783350?text=Hi"'}>
                                        <img className='whatsappimg' src={Logo} alt="img" />
                                    </Link>

                                </ul>
                            </div>


                        </div>
                    </div>

                </div>
            </div>
            <div className="copyright">
                <div className="copy">
                    <p>Copyright © 2025 QU - Lucency Private Limited. Powered By <Link to={'https://www.linkedin.com/in/abdul-azeem-7aa0291b8/'}> Abdul Azeem </Link></p>
                </div>
            </div>


        </>
    )
}

export default Footer